// extracted by mini-css-extract-plugin
module.exports = {"fieldsContainer":"CustomTab_fieldsContainer__2AOvh","field":"CustomTab_field__YL5XZ","noData":"CustomTab_noData__2hV9F","descriptionTexts":"CustomTab_descriptionTexts__vvgzB"};